/**
 * VERSIONE LIBRERIA 3
 */

var ViewRecord = CoreView.extend({
    _pkName : 'id',
    _pkValue : null,

    successMsg : function (msg) {
        var self = this;
        $(self.config.container).find('[data-alert]').removeClass('hide').html(msg);
        setTimeout(function () {
            $(self.config.container).find('[data-alert]').addClass('hide').html('');
        },1000);
    },
    /**
     * ritorna i valori di istanza dei parametri definiti nella funzione nei
     * dati del modello
     * @param func : function definita nell'oggetto
     * @return vettore di valori
     * */
    _buildFunctionParams : function (func) {
        var self = this;
        var params = {};
        var args = func.toString ().match (/function\s*\w*\s*\((.*?)\)/)[1].split (/\s*,\s*/);
        for (var a in args)
            params[args[a] ] = self.data.value[ args[a] ];
        return  _.values(params);
    },
    _evaluateFunctionProp : function (prop) {
        var self = this;
        if (!prop)
            return '';
        if (_.isFunction(prop)) {
            var fValues = self._buildFunctionParams(prop);
            return prop.apply(null, fValues);
        }
        return prop;
    },
    _render : function () {
        var self = this;
        // setto il template principale della view
        //console.log("EDIT ",self.jQe.find('[data-view_elements]'));
        self.jQe.find('[data-view_elements]').attr('data-view_elements',self.modelName);
        self._setKeys();
        for (var key in self.keys) {
            self._renderElement(self.keys[key]);
        }

        for (var i in self.keys) {
            self.renderObjs[0][ self.keys[i] ].finalize();
        }
        //if (!self.isHasMany)
        self._renderActions();
        self._attachEvents();

        for (var i in self.keys) {
            self._connectFields( self.keys[i] );
        }

    },
    _configViewCustomComplex : function () {
        var self = this;
        // solo la prima volta mi prendo i riferimenti ai template
        if (Object.keys(self._customAttrs) == 0) {
            self._customAttrs.container = $(self.config.container);
            self._customAttrs.sourceHtml = $.getDomTemplate(self._customAttrs.container).html();
            self._customAttrs.actionTpl = '#default_view_edit_action_item_tpl';
            //self._customAttrs.actionGlobalTpl = '#default_view_global_action_tpl';
        }
    },
    _renderViewCustomComplex : function () {
        var self = this;
        // creo gli oggetti render

        $(self._customAttrs.container).html(self._customAttrs.sourceHtml);
        $.each($(self._customAttrs.container).find('render'), function() {
            self._createRender($(this),$(this).attr('data-field'));
        });

        // chiamo la funzione render per ogni oggetto
        for (var k in self.renderObjs[0]) {
            self.renderObjs[0][k].render();
        }

        // chiamo la funzione finalize per ogni oggetto
        for (var k in self.renderObjs[0]) {
            self.renderObjs[0][k].finalize();
        }

        var configAction = self._getActionsConfig();
        console.log(configAction);
        var _findAction = function (name) {
            for (var i in configAction) {
                if (configAction[i].action == name)
                    return configAction[i];
            }
            return null;
        }

        $.each($(self.config.container).find('action'), function () {
            var name = $(this).attr('name');
            var actionData = _findAction(name);
            if (!actionData) {
                throw "action not found " + name;
            }
            var tplData = self._getTemplateActionData(actionData);
            var html = $.getTemplate(self._customAttrs.actionTpl, tplData);
            $(this).html(html);

        });

        self._attachEvents();
        for (var i in self.keys) {
            self._connectFields( self.keys[i] );
        }
    },
    
    _configViewCustomBase : function () {
        var self = this;
        // solo la prima volta mi prendo i riferimenti ai template
        var container = $.createDynamicContainer(self.config.container);;
        if (Object.keys(self._customAttrs) == 0) {
            //self._customAttrs.container = $(self.config.container);
            self._customAttrs.sourceContainer =  '#' + container.attr('id');
            //self._customAttrs.actionTpl = '#default_view_single_action_item_tpl';
            //self._customAttrs.actionGlobalTpl = '#default_view_global_action_tpl';
        }
    },
    _renderViewCustomBase : function () {
        var self = this;
        var tplData =  self.data.value;
        $.renderTemplate($(self._customAttrs.sourceContainer),self.config.container,tplData);

    },
    _setKeys : function () {
        var self = this;
        log.debug('ViedEdit._setKeys',self.config.fields);
        self.keys = self.config.fields;//Object.keys(self.config.fields);
        if (self.keys.length === 0) {
            if (self.data.value)
                self.keys = Object.keys(self.data.value);
        }

    },

    _getDefaultStructure : function(key) {
        var self = this;
        var label = 'left';

        switch(self._getRenderType(key)){
            case 'hasmany':
            case 'hasmany_through':
            case 'upload':
            case 'video':
                label = 'no';
                break;
        }

        var config = self._getRenderConfig(key);

        if (config.label) {
            return config.label;
        }

        return label;
    },

    _renderElement : function (key) {
        var self = this;
        var type = self.config.fields_type[key]?self.config.fields_type[key].type:'input';
        // caso speciale per gli hidden che non hanno struttura html
        if (type == 'input' && self.config.fields_type[key] && self.config.fields_type[key].inputType=="hidden") {
            var container = $.createDynamicContainer();
            var r = self._createRender(container,key);
            r.render();
            self.jQe.find('[data-hidden_fields]').append(container.html());
            r.container = self.jQe.find('[data-hidden_fields]');
            container.remove();
            return ;
        }

        var structure = self._getDefaultStructure(key); //self.config.labels?self.config.labels:'left';
        log.debug('key',key,'templateId','#'+self.prefixTemplateClass+'_' + structure + '_view_edit_tpl');
        var container = $.createDynamicContainer('#'+self.prefixTemplateClass+'_' + structure + '_view_edit_tpl');

        var safeKey = key.replace(/[\])}\[{(]/g, '');
        container.find('.' + self.type + '-field').addClass('field-' + safeKey + ' ' + self.modelName + '-field-' + safeKey);
        //container.first().attrs()
        //container.find('div').addClass('view-field-'+safeKey);
        //if (!window.bo)
        //    window.bo = container.first();
        $(container.first().children()[0]).addClass('view-field-'+safeKey);
        //console.log('aaaaa',container.first()[0].attributes);
        self._translateItem(container, safeKey);
        if (self.langs.length > 1) {
            var imgLang = self._langField(self.config,key);
            self._renderImgLang(container,imgLang);
        }
        container.find('[data-field_value]').attr('data-field_value',key);
        //console.log(container.html());

        self.jQe.find('[data-view_elements="' + self.modelName + '"]').append(container.html());
        container.remove();
        var realContainer = self.jQe.find('[data-view_elements="' + self.modelName + '"]').find('[data-field_value="' + key +'"]');

        var r = self._createRender(realContainer,key);
        r.render();
    },

    _createRender : function (container,key) {
        var self = this;
        var type = self._getRenderType(key);
        var classData = Render.getClassData(type);



        // i dati potrebbero essere recuperati con chiamata ajax percio' devo aggiornali dopo

        var rdata = {} ;
        var rconfig = self._getRenderConfig(key,classData);
        rconfig.container = container;
        rconfig.container.addClass('field-'+key);
        var render = Render.factory(self._getFieldName(key), _.extend(rconfig,rdata),type);
        if (!render) {
            log.error('ViewRecord._createRender failed',key,type,classData);
        }
        if (!self.renderObjs[0])
            self.renderObjs[0] = {};

        self.renderObjs[0][key] = render;
        rdata =  self._getRenderData(key,classData);
        render.attrs(rdata);
        return render;
    },

    _getActionsConfig : function () {
        var self = this;
        var actionData =  [];
        for (var i in self.config.actions) {
            var akey = self.config.actions[i];
            if (self.config.extra_actions && self.config.extra_actions[akey]) {
                var extra_action = self._buildSingleAction(akey,self.config.extra_actions[akey]);
                actionData.push(extra_action);
            } else if (defaultSingleActions[akey]) {
                actionData.push(defaultSingleActions[akey]);
            } else if (defaultGlobalActions[akey]) {
                //hasGlobalAction = true;
            } else {
                log.warn('Action not found with key ' + akey);
            }
        }
        return actionData;
    },

    _getTemplateActionData : function (actionObject) {
        var self = this;
        var tmpValues = new RecordAction(actionObject);
        //console.log('ACTION TEXT',actionData[a]);
        tmpValues.pk = self.data.value.id;
        tmpValues.actionText = self._evaluateFunctionProp(actionObject.actionText);
        tmpValues.actionTitle = self._evaluateFunctionProp(actionObject.actionTitle);
        tmpValues.actionIcon = self._evaluateFunctionProp(actionObject.actionIcon);
        tmpValues.actionClass = self._evaluateFunctionProp(actionObject.actionClass);
        tmpValues.visible = self._evaluateFunctionProp(actionObject.visible);
        tmpValues.enabled = self._evaluateFunctionProp(actionObject.enabled);
        tmpValues.href = null;
        tmpValues.params = self._buildFunctionParams(actionObject.func);
        if (tmpValues.control_type == 'link') {
            actionObject.view = self;
            tmpValues.href = actionObject.func.apply(actionObject, tmpValues.params);
            tmpValues.target = self._evaluateFunctionProp(actionObject.target);
        }
        tmpValues.params = JSON.stringify(tmpValues.params);
        return tmpValues;
    },
    _renderActions : function() {
        var self = this;
        log.debug("_renderActions",self.modelName,self.config.actions.length,self.isHasMany);
        if (self.config.actions.length == 0 || self.isHasMany) {
            self.jQe.find('[data-view_action]').remove();
        } else {
            var actionData = self._getActionsConfig();
            log.debug("actionData",actionData.length);
            if (actionData.length === 0) {
                self.jQe.find('[data-view_action]').remove();
                return ;
            }
            var actionsValues = [];
            for (var a in actionData) {
                var tmpValues = self._getTemplateActionData(actionData[a]);
                actionsValues.push(tmpValues);
            }
            log.debug(actionsValues,self.jQe.find('[data-view_action]'));
            $.renderTemplate(self.jQe.find('[data-view_action]'),self.jQe.find('[data-view_action]'),{data:actionsValues});
        }
    },

    /**
     * controlla che il campo e' un campo in lingua. In caso positivo ritorna il token della lingua
     * altrimenti null
     * @param modelConf : configurazione javascript
     * @param key : nome del campo da anlizzare
     */
    _langField : function (modelConf,key) {
        var self = this;
        //console.log("CoreView._langField check ",key,modelConf,self.config.lang_fields);
        for (var i in self.config.lang_fields) {
            var f = self.config.lang_fields[i];
            var lang = key.replace(new RegExp(f+'_', 'g'),'');
            if ($.inArray(lang,self.config.langs) >= 0) {
                log.debug('found key to translate',key,lang);
                return lang;
            }
        }
        return null;

    },
    /**
     * setta il src giusto dell'immagine dedicata alla lingua in base al token della lingua
     * @param lang : token lingua
     * @param obj : contenitore html
     */
    _renderImgLang : function (obj,lang) {
        if (!lang)
            return obj;
        obj.find("[data-img_lang]").attr("src","/viewimage/"+lang+".jpg/imagecache/lang-icon").removeClass("hide");
        return obj;
    },
    _getFieldName : function (key) {
        var self = this;
        return key;
    },
    _translateItem: function (obj, fieldkey) {
        var self = this;
        var key = fieldkey;
        key = Utility.camelCase(self.modelName) + '-' + fieldkey;
        key = key.replace(/[\])}\[{(]/g, '');
        if ($.langDefs[key + '_msg']) {
            console.log("find [data-html_msg]",obj.find('[data-html_msg]').length);
            //console.log('TRANSLATION exist ' + key + '_msg',self.data.translations[key + '_msg'])
            obj.find('[data-html_msg]').addClass(fieldkey + '-msg ' + key + '-msg').html($.translate(key + '_msg'));
        } else {
            obj.find('[data-html_msg]').hide();
        }

        if ($.langDefs[key + '_addedLabel']) {
            //console.log('TRANSLATION exist ' + key + '_addedLabel',self.data.translations[key + '_addedLabel'])

            obj.find('[data-html_addedLabel]').addClass(fieldkey + '-addedLabel ' + key + '-addedLabel').html($.translate(key + '_addedLabel'));
        } else {
            obj.find('[data-html_addedLabel]').hide();
        }
        //var label_html = obj.find('[data-html_label]').html();
        //obj.find('[data-html_label]').addClass(fieldkey + '-label ' + key + '-label').html(self.model.translations[key + '_label'] + '<br/>' + label_html);
        obj.find('[data-html_label]').addClass(fieldkey + '-label ' + key + '-label');
        obj.find('[data-html_field]').html($.translate(key + '_label') )

    },

    _attachEvents : function () {
        var self = this;
        for (var key in self.renderObjs[0]) {
            var render = self.renderObjs[0][key];
            var pk = self.data.value.id;
            self._attachEvent(render,pk);
        }
    },
    /**
     * restituisce l'oggetto data da assegnare all'oggetto render
     */
    _getRenderData : function (key,realType) {
        var self = this;
        var type = self._getRenderType(key);
        //if (realType)
        //    type = realType;
        // controllo che non ci sia definita una funzione speciale per i dati dell'oggetto render
        var funcName = '_get' + Render.getClassData(type) + 'Data';
        log.debug(key,type," check " + funcName);
        if (_.isFunction(self[funcName])) {
            return self[funcName](key);
        }
        var rdata = {
            value : self.data.value[key]
        };
        return rdata;
    },
    _getRenderMapData : function (key) {
        var self = this;
        log.debug('_getRenderMapData');
        var rconfig = self._getRenderConfig(key);
        var latValue = 0;
        var lngValue = 0;
        if (rconfig.center_map) {
            latValue = rconfig.center_map[0];
            lngValue = rconfig.center_map[1];
        }

        if (rconfig.belongsto) {
            var table = rconfig.lat_field.split('-')[0];
            var field = rconfig.lat_field.split('-')[1];
            if (self.data.value[table][field])
                latValue = self.data.value[table][field];
            field = rconfig.lng_field.split('-')[1];
            if (self.data.value[table][field])
                lngValue = self.data.value[table][field];
        }
        var rdata = {
            value :  {
                lat :latValue,
                lng :lngValue
            },
            mapKey : Facade.confs.mapKey,
        };
        return rdata;
    },

    _getRenderHasmanyData : function (key) {
        var self = this;
        // ridefinisco la jsonData per prendere tutti i valori resultParams attraverso
        // chiamata ajax
        //console.log(self.renderObjs[0]);
        var rdata = {
            value : self.data.value[key],
            //resultParams : _.has(self.data.resultParams[key],'resultParams')?self.data.resultParams[key].resultParams:self.data.resultParams[key].fields,
        };
        if (!self.renderObjs[0][key]) {
            log.warn('render hasmany ' + key +  ' viewkey ' + self.keyId +  " is undefined");
            return rdata;
        }
        self.renderObjs[0][key].getJsonData = function (callback) {
            /*
             var _callback = function (json) {
             if (json.error)
             callback([]);
             callback(json.result);
             }
             */
            self._controller.execute(
                'insertHasmany',
                {'model':Utility.snakeCase(self.data.resultParams[key].modelRelativeName)},
                {},
                callback
            );
        }
        var rdata = {
            value : self.data.value[key],
            //resultParams : _.has(self.data.resultParams[key],'resultParams')?self.data.resultParams[key].resultParams:self.data.resultParams[key].fields,
        };

        return rdata;
    },
    _getRenderAutocompleteData : function (key) {
        var self = this;
        var rconfig = self._getRenderConfig(key);
        var relationModel = rconfig.autocompleteModel;
        if (rconfig.relationModel) {
            relationModel = rconfig.relationModel;
        }
        var modelKey = Utility.camelCase(relationModel);
        var rdata = {
            value : self.data.value[key],
            modelData : self.data.value[modelKey]
        };
        return rdata;
    },

    _getRenderCustomData : function (key) {
        var self = this;
        /*
         var rconfig = self._getRenderConfig(key);
         var value = "";
         if (_.isFunction(rconfig.htmlValue)) {
         var fValues = self._buildFunctionParams(rconfig.htmlValue);
         value = rconfig.htmlValue.apply(self, fValues);
         } else
         value = rconfig.htmlValue;
         */
        var rdata =  {
            value : self.data.value[key],
            modelData : self.data.value
        };
        return rdata;
    },

    _getRenderChoiceData : function(key) {
        var self = this;
        //alert("get render selct data " + key)

        log.debug('_getRenderChoiceData',key,self.data.resultParams[key]);
        var rconfig = self._getRenderConfig(key);
        var domainValues = {};
        var domainValuesOrder = false;
        if (_.isFunction(rconfig.domainValues)) {
            var fValues = self._buildFunctionParams(rconfig.domainValues);
            domainValues = rconfig.domainValues.apply(self, fValues);
        }
        else if (self.data.resultParams[key] && self.data.resultParams[key].options) {
            domainValues = self.data.resultParams[key].options;
            if(self.data.resultParams[key].options_order) {
                domainValuesOrder = self.data.resultParams[key].options_order;
            }
        }
        var rdata = {
            value : self.data.value[key],
            domainValues : domainValues,
            domainValuesOrder : domainValuesOrder,
        };
        return rdata;
        /*
         var rdata = {
         value : self.data.value[key],
         domainValues : self.data.resultParams[key].options
         };
         return rdata;
         */
    },

    _getRenderSelectData : function(key) {
        var self = this;
        log.debug('_getRenderSelectData',key,self.data.resultParams[key]);
        var rconfig = self._getRenderConfig(key);
        var domainValues = {};
        var domainValuesOrder = false;
        if (_.isFunction(rconfig.domainValues)) {
            var fValues = self._buildFunctionParams(rconfig.domainValues);
            domainValues = rconfig.domainValues.apply(self, fValues);
        } else if (rconfig.domainValues) {
            domainValues = rconfig.domainValues;
        } else if (self.data.resultParams[key] && self.data.resultParams[key].options) {
            domainValues = self.data.resultParams[key].options;
            if(self.data.resultParams[key].options_order) {
                domainValuesOrder = self.data.resultParams[key].options_order;
            }
        }

        var rdata = {
            value : self.data.value[key],
            domainValues : domainValues,
            domainValuesOrder : domainValuesOrder,
        };
        return rdata;
    },
    _getRenderInputHelpedData : function(key) {
        var self = this;
        log.debug("_getRenderInputHelpedData",key,self.data.resultParams[key]);
        var rconfig = self._getRenderConfig(key);
        var domainValues = {};
        var domainValuesOrder = false;
        if (_.isFunction(rconfig.domainValues)) {
            var fValues = self._buildFunctionParams(rconfig.domainValues);
            domainValues = rconfig.domainValues.apply(self, fValues);
        }
        else if (self.data.resultParams[key] && self.data.resultParams[key].options) {
            domainValues = self.data.resultParams[key].options;
            if(self.data.resultParams[key].options_order) {
                domainValuesOrder = self.data.resultParams[key].options_order;
            }
        }
        var rdata = {
            value : self.data.value[key],
            domainValues : domainValues,
            domainValuesOrder : domainValuesOrder,
        }
        return rdata;
    },
    _getRenderBetweenDateData : function (key) {
        var self = this;
        var rconfig = self._getRenderConfig(key);
        //console.log("aaaaaaaaaaa",rconfig,self.data.value,self.data.value[rconfig.date_end]);
        var rdata = {
            value : self.data.value[key],
            end_value : self.data.value[rconfig.end_key],
        }
        return rdata;
    },
    _getRenderRangeData : function (key) {
        var self = this;
        var rconfig = self._getRenderConfig(key);
        //console.log("aaaaaaaaaaa",rconfig,self.data.value,self.data.value[rconfig.date_end]);
        var domainValues = {};
        var domainValuesOrder = null;
        if (_.isFunction(rconfig.domainValues)) {
            var fValues = self._buildFunctionParams(rconfig.domainValues);
            domainValues = rconfig.domainValues.apply(self, fValues);
        } else if (rconfig.domainValues) {
            domainValues = rconfig.domainValues;
        } else if (self.data.resultParams[key] && self.data.resultParams[key].options) {
            domainValues = self.data.resultParams[key].options;
            if(self.data.resultParams[key].options_order) {
                domainValuesOrder = self.data.resultParams[key].options_order;
            }
        }
        var rdata = {
            value : self.data.value[key],
            end_value : self.data.value[rconfig.end_key],
            domainValues : domainValues,
            domainValuesOrder : domainValuesOrder,
        }
        // nel caso di chiavi uguali considero value un array
        if (key == rconfig.end_key && self.data.value[key]) {
            rdata.value = self.data.value[key][0];
            rdata.end_value = self.data.value[key][1];
        }



        return rdata;
    },
    // setta il valore dell'oggetto render di key
    setRenderData : function (key,value) {
        var self = this;
        if (!self.renderObjs[0][key])
            throw "Render with key= " + key + " not found";
        self.renderObjs[0][key].setValue(value);
    },
    // restituisce l'oggetto render associato alla key
    getRenderObj : function(key) {
        return this.renderObjs[0][key];
    },
    /**
     * crea il vettore dei campi connessi ad un determinata key
     */
    _connectFields : function (key) {
        var self = this;
        if (!self.renderObjs[0][key])
            return ;
        if (self.renderObjs[0][key].dependencies) {
            var dependencies = self.renderObjs[0][key].dependencies;
            for (var k in dependencies.sources) {
                var sourceKey = dependencies.sources[k];
                if (!self.connectedObjs[sourceKey])
                    self.connectedObjs[sourceKey] = [];
                //alert('connect ' + sourceKey + " to "  + key);
                self.connectedObjs[sourceKey].push(key);
                // spedisco l'evento per la configurazione iniziale
                self.renderObjs[0][sourceKey]._emitEvent('change',self.data.value[sourceKey])
            }
        }
    },
    fireToConnected : function (evt) {
        var self = this;
        for (var k in self.connectedObjs) {
            var key = k;
            if (self.isHasMany) {
                key = self._getFieldName(key);
            }
            if (key == evt.key) {
                for (var i in self.connectedObjs[k]) {
                    var destKey = self.connectedObjs[k][i];
                    log.debug('ViewRecord.fireToConnected evt',evt,'rObject',self.renderObjs[0][destKey]);
                    var func = self.renderObjs[0][destKey].dependencies.func;
                    if (!_.isFunction(func) ) {
                        throw "func is not function in object " + destKey;
                    }
                    var container = $(self.config.container).find(self.renderObjs[0][destKey].container);

                    func.apply(self,[evt,container]);

                }
            }
        }
        return ;
        // codice non tiene conto quando una view e' hasmany
        var self = this;
        if (self.connectedObjs[evt.key]) {
            for (var i in self.connectedObjs[evt.key]) {
                var destKey = self.connectedObjs[evt.key][i];
                log.debug('ViewRecord.fireToConnected evt',evt,'rObject',self.renderObjs[0][destKey]);
                var func = self.renderObjs[0][destKey].dependencies.func;
                if (!_.isFunction(func) ) {
                    throw "func is not function in object " + destKey;
                }
                var container = $(self.config.container).find(self.renderObjs[0][destKey].container);

                func.apply(self,[evt,container]);

            }
        }
    }
});